<template>
  <div class="form-group filter-item">
    <label class="control-label">{{ filter.label }}</label>
    <date-range-picker
      @update="handleUpdate"
      :date-range="{startDate: startDate, endDate:endDate}"
      :ranges="false"
      control-container-class="control-container"
    >
      <template v-slot:input="picker">
        <input
          class="form-control"
          type="text"
          :value="inputValue"
          placeholder="YYYY-MM-DD - YYYY-MM-DD"
        >
      </template>
    </date-range-picker>
  </div>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker';

export default {
  components: {DateRangePicker},
  props: ['filter'],
  methods: {
    handleUpdate(val) {

      this.$set(this.filter, 'value', {
        from: this.$moment(val.startDate).format('YYYY-MM-DD'),
        to: this.$moment(val.endDate).format('YYYY-MM-DD')
      })

      this.$emit('value-updated');
    }
  },
  computed: {
    inputValue() {
      return this.startDate && this.endDate ? `${this.startDate} - ${this.endDate}` : null
    },
    startDate() {
      return this.filter.value && this.filter.value.from ? this.filter.value.from : null
    },
    endDate() {
      return this.filter.value && this.filter.value.to ? this.filter.value.to : null
    }
  }
}
</script>